import { useEffect, useRef, useState } from 'react';

/** Matches AnimatedTabsList pill transition duration */
export const TAB_PANEL_DEFER_MS = 320;

/**
 * Delays mounting heavy tab panels until the tab indicator animation finishes.
 * After the first visit, the panel mounts immediately on return.
 */
export function useDeferredTabMount(activeTab: string, tab: string): boolean {
  const hasVisitedRef = useRef(false);
  const [showPanel, setShowPanel] = useState(false);

  useEffect(() => {
    if (activeTab !== tab) return;

    if (hasVisitedRef.current) {
      setShowPanel(true);
      return;
    }

    setShowPanel(false);
    const timer = window.setTimeout(() => {
      hasVisitedRef.current = true;
      setShowPanel(true);
    }, TAB_PANEL_DEFER_MS);

    return () => window.clearTimeout(timer);
  }, [activeTab, tab]);

  return showPanel;
}
